import styles from './footer-background.module.scss';

const FooterBackground = () => <div className={styles.component} />;

FooterBackground.displayName = 'FooterBackground';

export default FooterBackground;
